module.exports = __webpack_public_path__ + "images/project-6a4636f5a38186df4cbde10eb7c3677a.jpg";